export default "__VITE_ASSET__54ab6f8e__"